import { ROUTES } from '@aibees/elephant/router';
import { PopoverListButtonProps } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils/class-names';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ENRICH_ACTION_MENU_ITEMS } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import {
  type EnrichTableActionProps as Props,
  EnrichTableActionType as Action,
} from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;

export const EnrichTableAction = memo(({ className, item }: Props) => {
  const navigate = useNavigate();

  const handleSelect: PopoverListButtonProps['onSelect'] = (e) => {
    if (e.key === Action.view) navigate(ROUTES.enrichPage);
  };

  return (
    <Styled.Wrapper
      className={classnames('EnrichTableAction', className)}
      icon="more-horizontal"
      variant="outlined"
      size="xsmall"
      popoverSx={SX.popover}
      contentSx={SX.content}
      itemSx={SX.item}
      itemDivider={true}
      anchorOrigin={ANCHOR_ORIGIN}
      transformOrigin={TRANSFORM_ORIGIN}
      items={ENRICH_ACTION_MENU_ITEMS}
      onSelect={handleSelect}
    />
  );
});

EnrichTableAction.displayName = 'EnrichTableAction';
